import $ from "jquery";
//import jsmediatags from 'jsmediatags-web';
//import jsmediatags from 'jsmediatags';
//import * as mm from 'music-metadata/lib/core';
class AudioUtil {
  audio: HTMLAudioElement;
  private waiting = false;
  private errorCalback: () => void;
  constructor(src?: string) {
    this.audio = $("#audio-element-player")[0] as HTMLAudioElement;
    if (!this.audio) {
      this.audio = new Audio(src);
    }
  }

  sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  play(src = "", medItem = null, srcIndex = null, obj = this) {
    const srcIndexGiven = srcIndex;
    const repeatInterval = 2000;
    const startingSource =
      medItem && medItem.pathVariants
        ? Math.floor((Math.random() * medItem.pathVariants.length) / 2)
        : 0;
    if (srcIndex == null) {
      srcIndex = startingSource;
    }
    if (medItem.pathVariants) {
      if (medItem && medItem.pathVariants && medItem.pathVariants.length > 0) {
        src = medItem.pathVariants[srcIndex][medItem.currentQuality];
      }
    } else {
      medItem.pathVariants = [3][3];
    }

    if (medItem && !medItem.currentQuality && medItem.currentQuality != 0) {
      medItem.currentQuality = 1;
    }

    function errorHandler() {
      obj.play(
        medItem.pathVariants[0][medItem.currentQuality],
        medItem,
        0,
        obj
      );
    }

    function updateQualitySwitch(i) {
      $(".stream-switch").removeClass("active");
      $(".stream-switch").eq(i).addClass("active");
      $("#audio-element-player").attr("data-current-quality", i);
      document.cookie =
        "media-current-quality=" + i + "; max-age=2678400; path=/";
    }

    let source_string = obj.audio.src;
    if (obj.audio.src) {
      source_string = new URL(source_string).pathname;
    }
    if (source_string !== src) obj.audio.src = src;
    if (obj.audio.paused == obj.audio.paused) {
      if (obj.waiting) {
        obj.sleep(repeatInterval).then(() => {
          obj.play(src, medItem, srcIndex, obj);
          return;
        });
        return;
      }
      obj.waiting = true;
      let playPromise = obj.audio.play();
      playPromise.then(
        function (value) {
          updateQualitySwitch(medItem.currentQuality);
          gtag('event', 'bottom_player_play', {
          'bottom_player_url': obj.audio.src,
          'bottom_player_type': 'playback_start_success'
        });
          obj.removeEvent("ended", obj.errorCalback);
        if (Array.isArray(medItem.pathVariants) && medItem.pathVariants.length > 0)
{          obj.errorCalback = errorHandler;
          obj.addEvent("ended", obj.errorCalback, {
            once: true,
            capture: true,
          });}
          obj.waiting = false;
        },
        function (reason) {
          obj.waiting = false;
          if (medItem && medItem.pathVariants) {
            if (srcIndexGiven == null) srcIndex = 0;
            else srcIndex++;
            if (srcIndex >= medItem.pathVariants.length) {
              obj.sleep(repeatInterval).then(() => {
                obj.play(
                  medItem.pathVariants[3][medItem.currentQuality],
                  medItem,
                  3,
                  obj
                );
                return;
              });
            } else {
              if (
                medItem &&
                medItem.pathVariants &&
                medItem.pathVariants.length > 0 &&
                (medItem.pathVariants[srcIndex][medItem.currentQuality] ||
                  medItem.pathVariants[srcIndex][medItem.currentQuality] == "")
              ) {
                obj.play(
                  medItem.pathVariants[srcIndex][medItem.currentQuality],
                  medItem,
                  srcIndex,
                  obj
                );
              }
            }
          }
        }
      );
    }
  }

  pause() {
    this.audio.pause();
  }
  addEvent(type, func, options = { once: false, capture: true }) {
    this.audio.addEventListener(type, func, options);
  }
  removeEvent(type, func) {
    this.audio.removeEventListener(type, func, true);
  }
  getProgress() {
    const progress = (this.audio.currentTime / this.audio.duration) * 100;

    return progress;
  }
  getDuration() {
    return this._timeToString(this.audio.duration);
  }
  getTime() {
    return this._timeToString(this.audio.currentTime);
  }
  getTimeRaw() {
    return this.audio.currentTime;
  }
  getVolume() {
    return this.audio.volume;
  }
  setVolume(volume) {
    this.audio.volume = volume;
  }
  setTime(percent) {
    const time = this._percentToTime(percent);
    if (isFinite(time)) this.audio.currentTime = time;
  }
  _percentToTime(percent) {
    return this.audio.duration * (percent / 100);
  }
  _timeToString(time) {
    if (!isFinite(time)) return "";
    const minutes = Math.trunc(time / 60);
    const seconds = Math.trunc(time - minutes * 60);
    return `${minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  }
}
export default AudioUtil;
